"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div `
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5%;
    position: relative;
    > div {
        flex: 1;
    }
    .ecrfs-left {
        display: flex;
        justify-content: center;
        align-content: center;
        flex-direction: column;
        align-self: flex-start;
        @media screen and ${constants_1.Device.tablet} {
            z-index: 1;
        }
    }
    .ecrfs-right {
        img {
            width: 100%;
        }
        @media screen and ${constants_1.Device.tablet} {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            opacity: 0.2;
        }
    }
`;
//# sourceMappingURL=FaqSectionStyled.js.map